export default __webpack_public_path__ + "static/bg-tower--mobile-dada9295d22eb207bbbfd1beb354fb5c.jpg";